var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('locale-selector',{attrs:{"list":Object.keys(_vm.locales),"store-list-value":[_vm.currentLocale]},on:{"input":(payload) => _vm.changeLocale(payload.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }